import React, { useState } from 'react'
import Page from '@/components/layout/Page'
import dynamic from 'next/dynamic'
import { usePlayer } from '@/lib/usePlayer'
import {CustomizeLiveProfile} from '@/pages/user-settings'
// live mode is client side
const LiveGame = dynamic(() => import('@/components/live/LiveGame'), { ssr: false })

const LiveModePage = () => {

  const { isLoading, data: player } = usePlayer();
  const [connectionFailed, setConnectionFailed] = useState(false);

  if (isLoading) {
    return <Page pageTitle={"Trivial Pursuit Live Stream"} mode="live"><div>Loading...</div></Page>
  }

  let loadingContent = <div>Loading Player Profile...</div>
  if (!player.avatar || !player.username) {
    loadingContent = <CustomizeLiveProfile player={player}/>
  } else {
    loadingContent = <LiveGame player={player} setConnectionFailed={(data) => setConnectionFailed(data)} connectionFailed={connectionFailed}/>
  }

  return (
    <Page pageTitle={"Trivial Pursuit Live Stream"} mode={connectionFailed ? 'sports' : 'live'}>
      {loadingContent}
    </Page>
  )
  
}

export default LiveModePage